export default __webpack_public_path__ + "static/media/lbng_red.fc09f2ed.png";